/* ================================================
   Injection Supplies — Site JavaScript
   ================================================ */

document.addEventListener('DOMContentLoaded', function () {
  // --- Mobile Navigation ---
  var navToggle = document.querySelector('.nav-toggle');
  var mobileMenu = document.querySelector('.mobile-menu');
  var mobileClose = document.querySelector('.mobile-close');
  var mobileOverlay = document.querySelector('.mobile-overlay');
  var mobileLinks = document.querySelectorAll('.mobile-nav-links a');

  function openMenu() {
    mobileMenu.removeAttribute('inert');
    mobileMenu.classList.add('active');
    mobileMenu.setAttribute('aria-hidden', 'false');
    navToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu.classList.remove('active');
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileMenu.setAttribute('inert', '');
    navToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (navToggle) {
    navToggle.addEventListener('click', openMenu);
  }
  if (mobileClose) {
    mobileClose.addEventListener('click', closeMenu);
  }
  if (mobileOverlay) {
    mobileOverlay.addEventListener('click', closeMenu);
  }
  mobileLinks.forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  // --- Escape Key Dismiss ---
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('active')) {
      closeMenu();
    }
  });

  // --- FAQ Accordion ---
  var faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function (item) {
    var button = item.querySelector('.faq-question');
    if (button) {
      button.addEventListener('click', function () {
        var isOpen = item.classList.contains('active');
        // Close all others
        faqItems.forEach(function (other) {
          other.classList.remove('active');
          var otherBtn = other.querySelector('.faq-question');
          if (otherBtn) {
            otherBtn.setAttribute('aria-expanded', 'false');
          }
        });
        // Toggle current
        if (!isOpen) {
          item.classList.add('active');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    }
  });

  // --- Dynamic Copyright Year ---
  var yearEls = document.querySelectorAll('.copyright-year');
  yearEls.forEach(function (el) {
    el.textContent = new Date().getFullYear();
  });

  // --- Nav Scroll Effect ---
  var nav = document.querySelector('.site-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    });
    // Check on load in case page is already scrolled
    nav.classList.toggle('scrolled', window.scrollY > 60);
  }

  // --- Product Image Gallery ---
  var thumbs = document.querySelectorAll('.gallery-thumb');
  var mainImage = document.getElementById('main-image');
  // Zoom should work even with a single image (no thumbnails). The thumb
  // click loop below is a no-op when there are none; the overlay builder
  // already falls back to the main image and hides prev/next for 1 image.
  if (mainImage) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        var newSrc = thumb.getAttribute('data-src');
        mainImage.removeAttribute('srcset');
        mainImage.src = newSrc;
        mainImage.alt = thumb.querySelector('img').alt;
      });
    });
    mainImage.style.cursor = 'zoom-in';
    mainImage.addEventListener('click', function () {
      // Build gallery items list from the thumb row (preserves display order).
      var galleryItems = Array.from(thumbs).map(function (t) {
        var thumbImg = t.querySelector('img');
        return { src: t.getAttribute('data-src'), alt: thumbImg ? thumbImg.alt : '' };
      });
      if (!galleryItems.length) {
        galleryItems = [{ src: mainImage.src, alt: mainImage.alt }];
      }
      var currentIndex = galleryItems.findIndex(function (it) {
        return mainImage.src.indexOf(it.src.replace(/^(https?:)?\/\//, '')) !== -1 || it.src === mainImage.src;
      });
      if (currentIndex < 0) currentIndex = 0;

      function highRes(url) { return url.replace(/width=\d+/, 'width=2048'); }

      var overlay = document.createElement('div');
      overlay.className = 'gallery-zoom-overlay';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Product image viewer');

      var closeBtn = document.createElement('button');
      closeBtn.className = 'gallery-zoom-close';
      closeBtn.setAttribute('aria-label', 'Close zoom');
      closeBtn.textContent = '\u00D7';

      var prevBtn = document.createElement('button');
      prevBtn.className = 'gallery-zoom-nav gallery-zoom-prev';
      prevBtn.setAttribute('aria-label', 'Previous image');
      prevBtn.type = 'button';
      prevBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6 9 12l6 6" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      var nextBtn = document.createElement('button');
      nextBtn.className = 'gallery-zoom-nav gallery-zoom-next';
      nextBtn.setAttribute('aria-label', 'Next image');
      nextBtn.type = 'button';
      nextBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      var counter = document.createElement('div');
      counter.className = 'gallery-zoom-counter';

      var img = document.createElement('img');

      function render() {
        var item = galleryItems[currentIndex];
        img.src = highRes(item.src);
        img.alt = item.alt;
        counter.textContent = (currentIndex + 1) + ' / ' + galleryItems.length;
        var multi = galleryItems.length > 1;
        prevBtn.style.display = multi ? '' : 'none';
        nextBtn.style.display = multi ? '' : 'none';
        if (multi) {
          var n = (currentIndex + 1) % galleryItems.length;
          var p = (currentIndex - 1 + galleryItems.length) % galleryItems.length;
          [n, p].forEach(function (i) { (new Image()).src = highRes(galleryItems[i].src); });
        }
      }
      function step(dir) {
        currentIndex = (currentIndex + dir + galleryItems.length) % galleryItems.length;
        render();
      }
      function close() {
        document.removeEventListener('keydown', onKey);
        overlay.remove();
        document.body.style.overflow = '';
      }
      function onKey(e) {
        if (e.key === 'Escape') { e.preventDefault(); close(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      }

      prevBtn.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
      nextBtn.addEventListener('click', function (e) { e.stopPropagation(); step(1); });
      closeBtn.addEventListener('click', function (e) { e.stopPropagation(); close(); });
      img.addEventListener('click', function (e) { e.stopPropagation(); });
      overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
      document.addEventListener('keydown', onKey);

      // Touch swipe
      var touchStartX = 0, touchStartY = 0, touchActive = false;
      overlay.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchActive = true;
      }, { passive: true });
      overlay.addEventListener('touchend', function (e) {
        if (!touchActive) return;
        touchActive = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - touchStartX;
        var dy = t.clientY - touchStartY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          e.preventDefault();
          step(dx < 0 ? 1 : -1);
        }
      });

      overlay.appendChild(closeBtn);
      overlay.appendChild(prevBtn);
      overlay.appendChild(img);
      overlay.appendChild(nextBtn);
      overlay.appendChild(counter);
      document.body.style.overflow = 'hidden';
      document.body.appendChild(overlay);
      render();
      closeBtn.focus();
    });
  }

  // --- Contact Form (mockup) ---
  var contactForm = document.getElementById('contact-form');
  var successMsg = document.getElementById('contact-success');
  if (contactForm && successMsg) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();
      contactForm.style.display = 'none';
      successMsg.classList.add('visible');
    });
  }

  // --- Scroll Reveal ---
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('visible'); });
  }
});

